import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricImprGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.impr.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.impr.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.impr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricImprGhaPPA;
